import React, { Component } from 'react';
import Global from '../../../Global';
import IchatWindow from './IchatWindow';
import './Ichat.css'
import ichatLogo from './../../../images/ichat/icon-chat.png';
import ichatDownLogo from './../../../images/ichat/icon-down.png';

class Ichat extends Component {

  constructor(props) {
    super(props);

    this.state = {
      visible:false
    };
  }
  
   componentDidMount(){
     document.onclick=(e) => this.hideCustomerLogin(e);
  }

  displayEnquiry(e){
  	if(Object.keys(this.props.item).length === 0){
  		window.location.href = this.props.iChatUrl
  	}else{
  		e.target.style.display = 'none';
	    let ichat = document.getElementsByClassName("start-ichat-div");
	    ichat[0].style.display = 'block';
  	}
  }
  
  hideEnquiry(e){
  	let ichat = document.getElementsByClassName("start-ichat-div");
    ichat[0].style.display = 'none';
    
    let icon = document.getElementsByClassName("ichat-icon");
    icon[0].style.display = 'block';
  }
  
  handleBtnClick(e){
//	e.nativeEvent.stopImmediatePropagation();
  	
//	let ichat = document.getElementsByClassName("start-ichat-div");
//  ichat[0].style.display = 'none';
//  
//  let icon = document.getElementsByClassName("ichat-icon");
//  icon[0].style.display = 'block';
//	
//	let customer = document.getElementsByClassName("customer-div");
//	customer[0].style.display = 'block';

		window.location.href = this.props.iChatUrl
  }
  
  hideCustomerLogin(e){
    if(e.target.classList[0] != "customer"){
      let customer = document.getElementsByClassName("customer-div");
      customer[0].style.display = 'none';
    }
  }
  
  startChat(){
    this.setState({
      visible:true
    });
  }
  
  getEnquiry(){
  	if(Object.keys(this.props.item).length === 0){
  		return ""
  	}else{
  		return (
  			<div className="descr">
        	{ this.props.item.name }  
        	{ this.getItem() }
          <div> $<i className="money">{ this.props.item.price } </i> /month </div>
        </div>
      )
  	}
  	
  }
  
  getItem(){
  	let html = this.props.item.detail.map((obj, index) =>
        <div key={index}>&nbsp; { obj } &nbsp;</div>
    );
    
    return html
  }

  render() {
      return (
        <div className="chat-div">
          <img className="ichat-icon" onClick={(e)=> this.displayEnquiry(e)} src={ichatLogo}/>
          <div className="start-ichat-div" style={{ display:'none' }}>
          	<div className="enquiry-div">
          	  <img className="icon-down" onClick={(e)=> this.hideEnquiry(e)} src={ichatDownLogo}/>
          		<div className="descr-title">Let's make an enquiry to know more details about the plan</div>
          		{ this.getEnquiry() }
          		<div className="start-ichat-button" onClick={(e)=> this.handleBtnClick(e)}>Start iChat</div>
          	</div>
          </div>
          <div className="customer customer-div" style={{ display:'none' }}>
            <div className="customer customer-tr">
              One-stop customer service experience
            </div>
            <div className="customer customer-tr customer-type">
              New Customer
            </div>
            <div className="customer customer-tr">
              <input className="customer" placeholder="Your Name" />
            </div>
            <div className="customer customer-tr login-type">
            or
            </div>
            <div className="customer customer-tr customer-type">
              Existing Customer/3Care
            </div>
            <div className="customer customer-tr customer-type">
              <input className="customer" placeholder="Prepaid / Mobile Number" />
            </div>
            <div className="customer customer-tr customer-type">
              <input className="customer customer-input" placeholder="Password" />
            </div>
            <div className="customer customer-tr customer-tip">
              3Gamer SIM service Is Instantly activated after login Set / Forgot Password
            </div>
            <div className="customer customer-tr customer-tip">
              (Prepaid SIM Customer:Please send a blank SMS to 503175)
            </div>
            <br/>
            <div className="start-chat" onClick={()=>this.startChat() }>
              Start
            </div>
          </div>
          <IchatWindow visible={this.state.visible}/>
        </div>
      )
  }
}

export default Ichat;